import angular, { IHttpInterceptor, IHttpResponse, IQService, IRootScopeService } from 'angular';

PermissionsInterceptorFactory.$inject = ['$q', '$rootScope'];

function PermissionsInterceptorFactory($q: IQService, $rootScope: IRootScopeService) {
  return {
    request: function (config) {
      return config;
    },
    requestError: function (rejection) {
      console.log('PermissionsInterceptorFactory::requestError', rejection);

      return $q.reject(rejection);
    },
    response: function (response) {
      return response;
    },
    responseError: function (response: IHttpResponse<unknown>) {
      switch (response.status) {
        case 403: {
          $rootScope.$broadcast('PermissionsInterceptorFactory::error', { type: 'permission' });
          break;
        }
      }

      return $q.reject(response);
    },
  } satisfies IHttpInterceptor;
}

export const PermissionsInterceptorFactoryModule = angular
  .module('acme.common.factory.permissionsInterceptor', ['ui.bootstrap'])
  .factory('PermissionsInterceptorFactory', PermissionsInterceptorFactory).name;
